import { getPortalBaseUrl } from 'app-constants';
import { removeSessionTokens } from 'utils/accessTokenLocalStorage';
import { logoutLocalStorage } from 'utils/loginLocalStorage';

const logoutUtil = (): void => {
  removeSessionTokens();
  logoutLocalStorage();

  return window.location.replace(`${getPortalBaseUrl()}/logout`);
};

export const redirectToPortal = (): void => {
  window.location.replace(`${getPortalBaseUrl()}/?targetUrl=webmail3`);
};

export default logoutUtil;
